import { render, staticRenderFns } from "./ChannelIcon.vue?vue&type=template&id=0463b6fe&scoped=true&functional=true"
import script from "./ChannelIcon.vue?vue&type=script&lang=js"
export * from "./ChannelIcon.vue?vue&type=script&lang=js"
import style0 from "./ChannelIcon.vue?vue&type=style&index=0&id=0463b6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0463b6fe",
  null
  
)

export default component.exports